module.exports = __webpack_public_path__ + "img/4.9de9ce55.jpg";